import { render } from "./TokenTranferFeedItem.vue?vue&type=template&id=688173fc"
import script from "./TokenTranferFeedItem.vue?vue&type=script&lang=js"
export * from "./TokenTranferFeedItem.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__